import React, { useEffect } from 'react'
import TitleHero from '../components/Hero/TitleHero'
import { Link } from 'react-router-dom'
import Page from '../layout/Page';

const Contact = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <Page
      title="Contact Us | Shoora - Leading telematics solutions"
      description="Shoora is a leading telematics solutions company, committed to providing innovative solutions for automotive and industrial sectors. Contact us today to discuss your needs and find a solution that meets your unique requirements."
      keywords="shoora contact us, shoora technologies, telematics solutions"
    >
       {/* <div className='contact-hero w-100' style={{ height: "60vh", overflow: 'hidden' }}

      >
        <img src="https://images.pexels.com/photos/6603941/pexels-photo-6603941.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" className='w-100' style={{ objectFit: "cover", overflow: "hidden" }} />
        <div className="container">
          <div className="row position-absolute py-5 w-100" style={{ top: '80px' }}>
            <div className="col col-12" style={{ backgroundColor: "" }}>

              <h1 className=' mb-4'
                style={{ fontSize: 150, opacity: "65%", color: "yellow", fontWeight: 900 }}
              >
                CONTACT
              </h1>


            </div>
          </div>
        </div>
      </div> */}
      <TitleHero 
      title="CONTACT"
      imgsrc="https://images.pexels.com/photos/6603941/pexels-photo-6603941.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
      />
      <div className="container my-5">
        <div className="row">
          <div className="col">
            <div className="contact-block">
              <h5>Technical Support</h5>
              <p>Having trouble with Shoora.com? Contact our Technical Support staff for assistance. <br /><a href="mailto:support@shoora.com">support@shoora.com</a></p>
              
            </div>
            <div className="contact-block">
              <h5>Corporate Headquarters</h5>
              <p>
              MashEye InfoTech Pvt. Ltd. <br />
              Unit 914A, 9th Floor, BPTP Park Centra,  <br />
              Sector - 30, Gurugram - 122002 <br />
              +91 97287 46672 <br />
              <a href="mailto:info@shoora.com">info@shoora.com</a> <br />
              View Shoora's Worldwide Office Locations
              </p>
            </div>
            <div className="contact-block">
              <h5>Become a Client</h5>
              <p>Interested in becoming a Shoora client? Contact us and let us work with you to discuss your needs. <br /> <a href="">Become a Client</a></p>
              
            </div>
            <div className="contact-block">
              <h5>Careers at Shoora</h5>
              <p>Shoora is where creativity meets action! A hub for innovation, where ideas come to life and initiative is celebrated. Learn, grow, and thrive in a workplace that empowers you every step of the way!
              <br /> <Link to="/careers">View Jobs</Link></p>
              
            </div>
            <div className="contact-block">
              <h5>Conferences</h5>
              <p>Have questions about a conference? <br /><a href="">Contact us</a></p>
            </div>
          </div>
          <div className="col col-12 col-md-3">
            <div className="contact-block">
              <h5>Worldwide Offices</h5>
              <p>
                <a href="">Asia</a> <br />
                <a href="">Africa</a> <br />
                <a href="">Middle East</a> <br />
              </p>
            </div>
            <div className="contact-block">
              <h5>Additional Contacts</h5>
              <p>
                <a href="">General Contacts</a> <br />
                <a href="">Analyst Relations</a> <br />
                <a href="">Media Relations</a> 
              </p>
            </div>
            <div className="contact-block">
              <h5>Need help logging in?</h5>
              <p>
                <a href="">Get login help</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default Contact